import styled, { css } from 'styled-components';
import { colors, layout } from '@prisjakt/ui-base';
import ProductCheckbox from '@prisjakt/ui-product-checkbox';
import { Link } from 'react-router-dom';

const SELECT_CHECKBOX_WIDTH = 30;

export const Row = styled.div.attrs({ 'data-test': 'ProductRow' })`
  position: relative;
  line-height: 1.2em;
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  ${props =>
    props.showDivider &&
    css`
      border-bottom: 1px solid ${p => p.theme.lines.primary};
    `}
  ${props =>
    props.selectable &&
    css`
      padding: 5px 0 5px ${SELECT_CHECKBOX_WIDTH}px;
    `}

  .pj-ui-product-core-properties {
    margin: 0;
  }
`;

export const ProductLink = styled(Link)`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  position: relative;
  padding: 5px 10px;
  outline: none;

  :hover::after,
  :focus::after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.02);
  }
`;

export const ProductImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  background: ${colors.lightGray1};
  border-radius: ${layout.borderRadius};

  .pj-ui-product-image {
    display: block;
    max-width: 40px;
    max-height: 40px;
    width: auto;
    height: auto;
  }
`;

export const BasicInfo = styled.div`
  flex: 1 1 100%;
  margin-right: 3px;
`;

export const ProductName = styled.div`
  :not(:last-child) {
    margin-bottom: 1px;
  }
`;

export const Subtitle = styled.div`
  color: ${p => p.theme.text.tertiary};
  font-size: 12px;
`;

export const CampaignBadge = styled.span`
  padding: 5px;
  max-height: 55px;
  min-width: 21px;
  flex: 0 1 55px;
  margin-left: 10px;
  text-align: center;
`;

export const PriceLabelWrapper = styled.span`
  flex: 1 1 auto;
  margin-left: 10px;
  white-space: nowrap;
  text-align: right;
`;

export const StoreCount = styled.span`
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  color: ${p => p.theme.text.tertiary};
  fill: ${p => p.theme.icons.tertiary};
  align-items: center;

  svg {
    height: 16px !important;
    width: 16px !important;
    margin-left: 2px;
  }
`;

export const Gutter = styled.span`
  display: flex;
  align-items: center;
  padding: 0 10px;
`;

export const SelectBox = styled(ProductCheckbox)`
  box-sizing: border-box;
  width: ${SELECT_CHECKBOX_WIDTH}px;
  cursor: pointer;
`;

export const SelectBoxWrapper = styled.label`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  &:hover label {
    box-shadow: 0 0 0 2px ${colors.yellow3};
  }
`;
